export function hasUserPermission(store) {
  return permissions => {
    const currentOrganizationPermissions =
      store.state.shell.currentOrganizationPermissions;
    permissions = Array.isArray(permissions) ? permissions : [permissions];

    for (let permission of permissions) {
      if (currentOrganizationPermissions.includes(permission)) return true;
    }
    return false;
  };
}

export function getOrSetOrganizationState(axios, commit, orgInfo) {
  if (Object.keys(orgInfo).length) {
    commit("shell/SET_CURRENT_ORGANIZATION_NAME", orgInfo.orgName);
    commit("shell/SET_CURRENT_ORGANIZATION_ID", orgInfo.orgSlug);
    axios.setHeader("Current-Organization", orgInfo.orgSlug);
    localStorage.setItem("currentOrganizationInfo", JSON.stringify(orgInfo));
  } else {
    if (localStorage.currentOrganizationInfo) {
      getOrSetOrganizationState(
        axios,
        commit,
        JSON.parse(localStorage.getItem("currentOrganizationInfo"))
      );
    }
  }
}

export function getOrSetOrganizationPermissions(commit, permissions) {
  if (permissions.length) {
    localStorage.setItem("currentPermissions", JSON.stringify(permissions));
    commit("shell/SET_CURRENT_ORGANIZATION_PERMISSIONS", permissions);
  } else {
    if (localStorage.currentUserInfo) {
      getOrSetOrganizationState(
        commit,
        JSON.parse(localStorage.getItem("currentPermissions"))
      );
    }
  }
}